import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useEffect, useState } from 'react';
import { I18nProvider as Provider } from './provider';
import { queryLangJson } from './api';
import i18nString from './i18nString';
import { formatResultData } from './utils';
var i18nSetLang = i18nString.i18nSetLang,
  i18nSetRtl = i18nString.i18nSetRtl;
var I18nProviderSlim = function I18nProviderSlim(_ref) {
  var children = _ref.children,
    defaultLangJson = _ref.defaultLangJson,
    defaultLang = _ref.defaultLang,
    ifSetHTMLLang = _ref.ifSetHTMLLang,
    ifSetRtl = _ref.ifSetRtl,
    i18nKey = _ref.i18nKey,
    loadingEle = _ref.loadingEle,
    onload = _ref.onload,
    token = _ref.token;
  var _useState = useState(defaultLang || 'zh-cn'),
    lang = _useState[0],
    setLang = _useState[1];
  var _useState2 = useState(defaultLangJson),
    langJson = _useState2[0],
    setLangJson = _useState2[1];
  var _useState3 = useState(false),
    load = _useState3[0],
    setLoad = _useState3[1];

  /**
   * 查询后端配置的语言
   */
  var queryJson = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var params, _yield$queryLangJson, result, _formatResultData, normal;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!i18nKey || load)) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          params = {
            locationList: i18nKey
          };
          if (token) {
            params.token = token;
          }
          _context.prev = 4;
          _context.next = 7;
          return queryLangJson(params);
        case 7:
          _yield$queryLangJson = _context.sent;
          result = _yield$queryLangJson.result;
          _formatResultData = formatResultData(result.translate), normal = _formatResultData.normal;
          normal && setLangJson(_extends({}, defaultLangJson, normal));
          result.language && setLang(result.language);
          setLoad(true);
          _context.next = 18;
          break;
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](4);
          setLoad(true);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 15]]);
  })), [i18nKey, load, defaultLangJson]);
  useEffect(function () {
    i18nKey && queryJson();
  }, [i18nKey, queryJson]);
  useEffect(function () {
    onload && onload(langJson);
  }, [langJson, onload]);
  useEffect(function () {
    // 没有接口请求直接本地使用的可以实现实时切换页面的语言
    !i18nKey && setLangJson(defaultLangJson);
  }, [defaultLangJson, i18nKey]);

  // 开启HTML的lang属性
  useEffect(function () {
    if (ifSetHTMLLang) {
      i18nSetLang(lang);
    }
  }, [ifSetHTMLLang]);

  // 开启RTL
  useEffect(function () {
    if (ifSetRtl) {
      i18nSetRtl(lang);
    }
  }, [ifSetRtl]);
  if (!load && i18nKey) {
    return loadingEle || /*#__PURE__*/React.createElement("span", null, "loading...");
  }
  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      langJson: langJson,
      lang: lang
    }
  }, children);
};
export default I18nProviderSlim;